import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { CategoryInputs } from "./CategoryInputs";

export const CategoryCreate = () => (
  <Create mutationMode="pessimistic" redirect="list">
    <SimpleForm className="max-w-2xl" defaultValues={{ direction: "expense" }}>
      <CategoryInputs />
    </SimpleForm>
  </Create>
);
